import Api from "~/service/Api";

class CreditNoCardOnFilePurchaseRepository {
  create(data) {
    return Api.post(`/credit/no-card-on-file-purchases`, data);
  }
}

export default CreditNoCardOnFilePurchaseRepository;
